import React from "react"

import { RichTextType } from "../types"

export function RichText(props: { content: RichTextType }) {
  return <div dangerouslySetInnerHTML={{ __html: props.content.html }}></div>
}
